import { api } from './api';

function buildListQuery(filters = {}) {
  const qs = new URLSearchParams();
  if (filters.status) qs.set('status', filters.status);
  if (filters.orderId) qs.set('orderId', filters.orderId);
  if (filters.page) qs.set('page', filters.page);
  if (filters.limit) qs.set('limit', filters.limit);
  const s = qs.toString();
  return s ? `?${s}` : '';
}

export const paymentService = {
  getAll: async (filters = {}) => {
    return api.get(`/api/payments${buildListQuery(filters)}`);
  },

  getById: async (id) => {
    return api.get(`/api/payments/${id}`);
  },

  // Cria cobrança para um pedido. method ∈ 'pix'|'boleto'|'credit_card'.
  // Retorna Payment + gateway (pixQrCode / invoiceUrl).
  generate: async (orderId, { method, dueDate, description } = {}) => {
    return api.post(`/api/payments/orders/${orderId}/generate`, {
      method,
      dueDate: dueDate || null,
      description: description || null
    });
  },

  // Stats computadas client-side (endpoint dedicado ainda não existe no backend)
  getStats: async (filters = {}) => {
    const list = await paymentService.getAll({ ...filters, limit: 100 });
    const rows = list.rows || [];
    const totalPaid = rows.filter(p => p.status === 'paid').reduce((s, p) => s + parseFloat(p.amount), 0);
    const totalPending = rows.filter(p => p.status === 'pending').reduce((s, p) => s + parseFloat(p.amount), 0);
    const totalOverdue = rows.filter(p => p.status === 'overdue').reduce((s, p) => s + parseFloat(p.amount), 0);
    return {
      total: list.count,
      pending: rows.filter(p => p.status === 'pending').length,
      paid: rows.filter(p => p.status === 'paid').length,
      overdue: rows.filter(p => p.status === 'overdue').length,
      cancelled: rows.filter(p => p.status === 'cancelled').length,
      totalPaid,
      totalPending,
      totalOverdue
    };
  },

  // Estes dois estavam no mock mas não têm endpoint no backend. Usuário marca
  // via webhook Asaas ou painel admin do gateway.
  markAsPaid: async () => {
    throw new Error('markAsPaid indisponível — use o webhook Asaas ou atualize via painel do gateway');
  },
  cancel: async () => {
    throw new Error('cancel indisponível — use o painel do gateway para cancelar cobranças');
  }
};

export default paymentService;
